import { render } from "./OtpVerificationDialog.vue?vue&type=template&id=62b40c09&scoped=true&ts=true"
import script from "./OtpVerificationDialog.vue?vue&type=script&lang=ts"
export * from "./OtpVerificationDialog.vue?vue&type=script&lang=ts"

import "./OtpVerificationDialog.vue?vue&type=style&index=0&id=62b40c09&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-62b40c09"]])

export default __exports__